export default {
    inserted(el) {
        const originalHeight = window.innerHeight;
        el._fixedBottomResizeHandler = () => {
            if (window.innerHeight < originalHeight - 100) {
                el.style.display = 'none'; // Vue2 常用直接隐藏
            } else {
                el.style.display = '';
            }
        };
        window.addEventListener('resize', el._fixedBottomResizeHandler);
    },
    unbind(el) {
        window.removeEventListener('resize', el._fixedBottomResizeHandler);
        delete el._fixedBottomResizeHandler;
    }
};